import { trackAmplitudeEvent } from '../../../analytics/CustomEvents'
import { setSearchOrigin } from '../../../utils/search/helpers'

export function trackVera (action, properties = {}) {
  const present = Object.fromEntries(Object.entries(properties).filter(([, value]) => value !== undefined && value !== null))

  try {
    trackAmplitudeEvent(`VERA ${action}`, present)
  } catch {
    // Analytics must never break the chat.
  }
}

// "listing id" is the name PDP Viewed, Product Added and Listing Purchased give a
// listing in Amplitude: a funnel holds it constant from a VERA click to the basket.
function resultProperties (tile) {
  const carousel = tile.closest('.vjs-vera-carousel')
  return {
    'listing id': Number(tile.dataset.productid),
    position: Number(tile.dataset.position) || undefined,
    vera_result_set_id: carousel?.dataset.resultSetId
  }
}

// auxclick catches a middle click (new tab).
export function bindResultTracking (container, conversationId) {
  function onClick (event) {
    if (event.type === 'auxclick' && event.button !== 1) return

    const wishlist = event.target.closest('.vjs-listing-tile-add-to-wishlist-button')
    const tile = event.target.closest('.vjs-vera-result')
    if (tile && wishlist) {
      return trackVera('Result Wishlist Clicked', { vera_conversation_id: conversationId(), ...resultProperties(tile) })
    }

    const link = event.target.closest('a')
    if (tile && link) {
      // The PLP's listings_source for a piece opened from the chat: a later add to
      // basket reports it as the search conversion's search_origin (Snowplow only;
      // in Amplitude, follow the listing id instead).
      setSearchOrigin(tile.dataset.productid, 'vera_chat')
      return trackVera('Result Clicked', {
        vera_conversation_id: conversationId(),
        click_target: link.classList.contains('vjs-vera-result-title') ? 'title' : 'image',
        new_tab: link.target === '_blank' || event.type === 'auxclick' || event.metaKey || event.ctrlKey,
        ...resultProperties(tile)
      })
    }

    // Action buttons report as Action Clicked (chat.js), not here.
    if (link?.href.includes('vera_results=') && !link.classList.contains('vjs-vera-action')) {
      return trackVera('See All Clicked', {
        vera_conversation_id: conversationId(),
        vera_result_set_id: new URL(link.href).searchParams.get('vera_results')
      })
    }

    const arrow = event.target.closest('.vjs-vera-carousel-prev, .vjs-vera-carousel-next')
    if (arrow) {
      trackVera('Carousel Scrolled', {
        vera_conversation_id: conversationId(),
        vera_result_set_id: arrow.closest('.vjs-vera-carousel').dataset.resultSetId,
        direction: arrow.classList.contains('vjs-vera-carousel-next') ? 'next' : 'previous'
      })
    }
  }

  container.addEventListener('click', onClick)
  container.addEventListener('auxclick', onClick)
}

// The free-text note stays server-side: only whether there was one is tracked.
export function trackListingFeedback (conversationId, tile, { listing_id: listingId, verdict, reason, note }) {
  trackVera('Listing Feedback Given', {
    vera_conversation_id: conversationId,
    ...(tile && resultProperties(tile)),
    'listing id': listingId,
    verdict,
    reason,
    has_note: Boolean(note)
  })
}

export function resultsViewedProperties (data) {
  const listings = data.payload?.listings || []
  return {
    vera_result_set_id: data.payload?.result_set_id,
    listing_ids: listings.map(hit => Number(hit.objectID)),
    positions: listings.map(hit => hit.__position),
    listing_count: listings.length
  }
}
